import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    title: "The plan is the promise.",
    body:
      "A capital program is a written commitment to shareholders. I treat the schedule as a contract, not a forecast.",
  },
  {
    n: "02",
    title: "Governance is upstream, not downstream.",
    body:
      "Stage-gates, FFL and PSSR exist to prevent — not to explain. Boards should be alerted before variance, not informed after it.",
  },
  {
    n: "03",
    title: "Numbers are moral.",
    body:
      "Every variance report has a human meaning: a safer plant, a retained job, a shareholder returned. I do not soften them.",
  },
  {
    n: "04",
    title: "Independence is a discipline.",
    body:
      "An independent director is only useful if they are willing to be inconvenient. My value at the table is not consensus.",
  },
  {
    n: "05",
    title: "The board is the last review.",
    body:
      "By the time an item reaches the board, information should be structured, tested and truthful. Executive dashboards should read like an audited page.",
  },
];

const row = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1, y: 0,
    transition: { duration: 0.9, delay: i * 0.07, ease: [0.22, 1, 0.36, 1] },
  }),
};

export default function Manifesto() {
  return (
    <section id="manifesto" className="relative border-b border-surface-2">
      <div className="mx-auto max-w-[1440px] px-6 md:px-16 py-28 md:py-40">
        <div className="grid grid-cols-12 gap-6 items-end mb-16">
          <div className="col-span-12 md:col-span-8">
            <div className="text-[11px] uppercase tracking-[0.28em] text-brass">
              <span className="tabular">11 —</span><span className="ml-3">Manifesto</span>
            </div>
            <h2 className="mt-4 font-serif-display font-light text-ivory text-5xl md:text-7xl leading-[0.95] tracking-[-0.02em]">
              A governance philosophy,<br />
              <span className="italic text-brass">written in five chapters.</span>
            </h2>
          </div>
        </div>

        <div>
          {chapters.map((c, i) => (
            <motion.div
              key={c.n}
              custom={i}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-60px" }}
              variants={row}
              className="grid grid-cols-12 gap-6 py-10 md:py-14 border-b border-surface-2 group"
            >
              <div className="col-span-3 md:col-span-2">
                <span className="font-serif-display text-brass text-6xl md:text-8xl italic leading-none tabular">
                  {c.n}
                </span>
              </div>
              <div className="col-span-9 md:col-span-6">
                <h3 className="font-serif-display text-ivory text-3xl md:text-5xl font-light leading-[1.05] tracking-[-0.01em] transition-colors duration-500 group-hover:text-brass">
                  {c.title}
                </h3>
              </div>
              <div className="col-span-12 md:col-span-4">
                <p className="text-mutedfg text-base md:text-lg leading-relaxed font-light">{c.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
